module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"city":"My city","citySaved":"New city saved.","change":"Change","errors":{"city":{"required":"City required"}}}}')
  delete Component.options._Ctor
}
